import device from './device';
export default { device: device };
//# sourceMappingURL=index.js.map